import { TransactionsState } from '~/reducers/transactions';
import { createSelector } from 'reselect';
import { getTransactionObjectIdFromProps } from '~/selectors/props.selectors';
import Transaction, { TransactionStatus } from '~/types/Transaction';
import { ApplicationState } from '../store';

export const getTransactionsState = (state: ApplicationState) => state.transactions;

export const getTransactionsData = createSelector(
  getTransactionsState,
  (transactionsState: TransactionsState) => transactionsState.data,
);

// FIXME: This selectors no longer work outside the context of batch
export const getSuccessfulTransactions = createSelector(getTransactionsData, (transactionsData) =>
  Object.values(transactionsData).filter(
    (transaction) => transaction.status === TransactionStatus.SUCCESS,
  ),
);

// FIXME: This selectors no longer work outside the context of batch
export const getFailedTransactions = createSelector(getTransactionsData, (transactionsData) =>
  Object.values(transactionsData).filter(
    (transaction) => transaction.status === TransactionStatus.ERROR,
  ),
);

export const getRefundIsLoading = createSelector(
  getTransactionsState,
  (transactionsState): boolean => transactionsState.isRefundLoading,
);

export const getTransactionByObjectId = createSelector(
  getTransactionsData,
  getTransactionObjectIdFromProps,
  (transactionsData, transactionId): Transaction | undefined => transactionsData[transactionId],
);

export const getFetchingTransactions = createSelector(
  getTransactionsState,
  (transactionsState): boolean => transactionsState.fetchingTransactions,
);

export const getSuccessfulTransactionsCount = createSelector(
  getTransactionsState,
  (transactionsState): number => transactionsState.successfulTransactionsCount,
);
